//
//
//
//
//
//

    export default {
        name: "detail",
        data() {
            return {
                img:""
            }
        },
        methods: {
            getProductDetail(){
                this.axios.get('https://m.mingyuanyun.com/wxapp-api/ad/get-product', {
                    params: {
                        pId:this.$route.query.id
                    }
                })
                    .then((res) => {
                        if(res.data){
                            const data=res.data.data;
                            this.img=res.data.data.product_main_url;

                            window.__myWebLogTracker__ &&
                            window.__myWebLogTracker__.report('产品-详情-查看', {
                                id: data.id,
                                name: data.product_title
                            });
                        }
                    })
            },
        },
        mounted() {
            this.getProductDetail();
        }
    }



// WEBPACK FOOTER //
// ./src/components/Productdetail.vue